<template>
  <div class="pd-home">
    <!-- 数据概览 -->
    <camp-data-board
      type="pd"
      :pbi="pbi"
      :iep="iep"
      @open="openStat"
    ></camp-data-board>
    <div class="section-error" v-if="overviewError">{{ overviewError }}</div>
    <!-- 负责中心 -->
    <div class="center-card">
      <div class="card-title">负责中心</div>
      <div class="center-item" v-for="item in centers" :key="item.id" @click="goCenter(item)">
        <img class="center-avatar" src="@/assets/images/researchCamp/banner.png" alt="">
        <div class="center-main">
          <div class="center-name">{{ item.name }}</div>
          <div class="center-meta">主任：{{ item.director }} {{ item.region }} 在营{{ item.count }}人</div>
        </div>
        <img class="center-arrow" src="@/assets/images/person/right.png" alt="">
      </div>
      <div class="center-state" v-if="!loading && !centersError && !centers.length">暂无负责中心</div>
    </div>
    <!-- 考试数据 -->
    <camp-exam-data-popup v-model="examVisible" :statistics="iep"></camp-exam-data-popup>
  </div>
</template>

<script>
import CampDataBoard from './CampDataBoard.vue'
import CampExamDataPopup from './CampExamDataPopup.vue'
import {
  getResearchCampStaffOverview,
  getResearchCampStaffHomeCamps
} from '@/api/researchCamp'

export default {
  name: 'CampPdHome',
  components: {
    CampDataBoard,
    CampExamDataPopup
  },
  props: {
    campConfigId: {
      type: [Number, String],
      default: null
    },
    viewRole: {
      type: String,
      default: 'PD'
    }
  },
  data () {
    return {
      examVisible: false,
      pbi: {},
      iep: {},
      loading: false,
      overviewError: '',
      centersError: '',
      centers: []
    }
  },
  created () {
    this.loadOverview()
    this.loadManagedCamps()
  },
  methods: {
    // 加载 PD 首页概览
    async loadOverview () {
      if (!this.campConfigId) {
        this.overviewError = '未获取到负责营信息'
        return
      }
      this.loading = true
      this.overviewError = ''
      try {
        const response = await getResearchCampStaffOverview(this.campConfigId, { viewRole: this.viewRole })
        const home = response && response.data ? response.data : {}
        this.pbi = home.statistics || {}
        this.iep = home.iepStatistics || {}
      } catch (error) {
        this.overviewError = error && error.msg ? error.msg : '数据概览加载失败'
      } finally {
        this.loading = false
      }
    },
    // 加载负责的研修营
    async loadManagedCamps () {
      this.centersError = ''
      try {
        const response = await getResearchCampStaffHomeCamps(this.viewRole)
        const camps = response && response.data ? response.data : []
        this.centers = camps.map(camp => ({
          id: camp.campConfigId,
          name: camp.campName || camp.hospitalName || '-',
          director: camp.directorName || '-',
          region: [camp.provinceName, camp.cityName].filter(Boolean).join('') || '-',
          count: this.formatMetric(camp.inCampLearnerCount)
        }))
      } catch (error) {
        this.centersError = error && error.msg ? error.msg : '负责中心加载失败'
        this.$toast(this.centersError)
      }
    },
    // 指标空值显示为横线，小数保留两位
    formatMetric (value) {
      if (value === null || value === undefined || value === '') return '-'
      const numeric = Number(value)
      return Number.isFinite(numeric) && !Number.isInteger(numeric)
        ? String(Number(numeric.toFixed(2)))
        : String(value)
    },
    // 考试打开弹窗，其余进入对应页
    openStat (item) {
      if (item.key === 'exam') {
        this.examVisible = true
        return
      }
      if (item.path) {
        this.$router.push({
          path: item.path,
          query: Object.assign({ viewRole: this.viewRole }, item.query || {})
        })
      }
    },
    // 进入中心后复用主任页，并带上定制任务入口
    goCenter (item) {
      this.$router.push({ path: '/researchCamp/mine', query: { researchCampId: item.id, viewRole: this.viewRole, from: 'pd' } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.pd-home {
  padding-bottom: 24px;

  .section-error {
    padding: 8px @camp-side;
    font-size: 12px;
    color: @camp-red;
  }

  .center-card {
    .camp-white-card();
    margin-top: 13px;
    padding: 16px 14px;

    .card-title {
      margin-bottom: 4px;
      font-size: 14px;
      font-weight: 600;
    }

    .center-item {
      display: flex;
      align-items: center;
      padding: 12px 0;

      & + .center-item {
        border-top: 1px solid @camp-line;
      }
    }

    .center-state {
      padding: 18px 0;
      text-align: center;
      font-size: 12px;
      color: @camp-sub;
    }

    .center-avatar {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      border-radius: 50%;
      object-fit: cover;
    }

    .center-main {
      flex: 1;
      min-width: 0;
    }

    .center-name {
      font-size: 14px;
      line-height: 20px;
    }

    .center-meta {
      font-size: 12px;
      line-height: 18px;
      color: @camp-sub;
    }

    .center-arrow {
      width: 12px;
      margin-left: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampPdHome.vue